import axios from "axios";

const autenticacion = {
  state: () => ({
    usuario: null,
    auth: false,
  }),

  getters: {
    usuario: (state) => {
      return state.usuario;
    },

    auth: (state) => {
      return state.auth;
    },

    perfilAdminNacional: (state) => {
      return state.usuario.usuario_perfil.some(usuario => usuario.perfil_id == 1);
    },

    perfilLiderCentroFormacion: (state) => {
      return state.usuario.usuario_perfil.some(usuario => usuario.perfil_id == 2);
    },

    perfilLiderNacional: (state) => {
      return state.usuario.usuario_perfil.some(usuario => usuario.perfil_id == 3);
    },

    perfilEnlaceRegional: (state) => {
      return state.usuario.usuario_perfil.some(usuario => usuario.perfil_id == 5);
    },

    perfilExpertoNacional: (state) => {
      return state.usuario.usuario_perfil.some(usuario => usuario.perfil_id == 4);
    },

    perfilExpertoRegional: (state) => {
      return state.usuario.usuario_perfil.some(usuario => usuario.perfil_id == 6);
    },
  },

  mutations: {
    enviarUsuario(state, usuario) {
      state.usuario = usuario.usuario;
      state.auth = usuario.auth;
    },
  },

  actions: {
    async iniciarSesion(context, usuario) {
      try {
        await axios.get("sanctum/csrf-cookie")
        await axios.post("login", usuario)
        await context.dispatch("autenticar")
      } catch (error) {
        throw new Error("error: ", error);
      }
    },

    async autenticar(context) {
      try {
        const { data } = await axios.get("api/user")
        const usuario = {
          usuario: data,
          auth: true,
        };
        context.commit("enviarUsuario", usuario);
      } catch (error) {
        throw new Error("error: ", error);
      }
    },

    async cerrarSesion(context) {
      try {
        await axios.post("logout")
        const usuario = {
          usuario: null,
          auth: false,
        };
        context.commit("enviarUsuario", usuario);

      } catch (error) {
        throw new Error("error: ", error);
      }
    },
  },
};

export default autenticacion;
